<main class="mat-body">
    <div class="container progress-bar-wrapper">
        <div class="row">
            <div class="col-12">
                <thr-contract-progress-contribution [percent]="66"></thr-contract-progress-contribution>
            </div>
        </div>
    </div>

    <div class="container" *ngIf="transfer">
        <div class="row">
            <div class="col-12">
                <div class="row flex-nowrap justify-content-between align-items-end">
                    <div class="col-auto flex-shrink-1">
                        <h1 class="text-blue mat-display-1 mt-4 mb-0" [innerHTML]="'contribution.detail'|translate"></h1>
                    </div>
                </div>
                <hr class="mt-1 mb-3" />
            </div>
        </div>

        <form #formTransfer="ngForm" novalidate autocomplete="off" (submit)="onSubmit()">
            <thr-transfer-form [transfer]="transfer"></thr-transfer-form>

            <div class="row justify-content-end mt-5 mb-4">
                <div class="col-12 col-sm-6 col-md-4">
                    <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!formTransfer.valid || !transfer.isComplete(0.01)">
                        {{ 'general.continue'|translate }}
                    </button>
                </div>
            </div>
        </form>
    </div>
</main>